import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  isLoading: false,
  isForceLoading: false,
  isOn: true,
  isFocus: false,
  modalAlertComponents: [],
  modalComponents: [],
  toast: {
    isShow: false,
    message: '',
    duration: 1500
  },
  keywords: [],
  fromStorePath: '',
  routeLayout: {
    isHeader: false,
    titleName: '',
    isBack: false,
    isNav: false,
    isArea: false,
    isCart: false,
    isShare: false,
    isSearch: false,
    isHome: false,
    isQuit: false,
    isStore: false
  },
  keepAlive: [],
  // keepAliveInner: null,
  scrollTop: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
